import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { analyticsContext } from '../../contexts/AnalyticsContext'
import BreadcrumbsComponent from '../../components/Breadcrumbs'
import setLastBreadcrumbs from '../../actions/setLastBreadcrumbs'
import ClientAPI from '../../common/ClientAPI'
import Container from '../../functional-components/grid/Container'
import ProductsList from '../../components/ProductsList'
import ClientStorage from '../../common/ClientStorage'
import addOneToCart from '../../actions/addOneToCart'
import addToCart from '../../actions/addToCart'
import setLastPage from '../../actions/setLastPage'
import BannersCarousel from '../../functional-components/BannersCarousel'
import SisterCategories from '../../components/SisterCategories'
import {
  urlToSearchState,
  urlToBannerSlotState,
  searchStateToUrl,
  validateInput,
  getSearchStateFilter,
  getSpecialEventData,
} from '../../Helpers'
import LegalInfo from '../../components/LegalInfo'
import WalstoreBackButton from '../../components/WalstoreBackButton'
import CategoriesCarouselAbTesting from '../../components/CategoriesCarouselAbTesting'
import { ORIGINS, sendSearchResultReport, sendSimpleEvent } from '../../common/GoogleTagManager'
import VoidPLP from '../../functional-components/VoidPLP'
import './index.css'
import getBannersCategoryClient from '../../common/clients/getBannersCategoryClient'
import getCategoriesMenu from '../../common/clients/getCategoriesMenuClient'
import { detectDevice, getCategoryDataBase, retryQueryBase } from './utils'
import AnalyticsConstants from '../../contexts/AnalyticsContext/constants.json'
import { handleRefinementList } from '../../Helpers/facetHelper'
import setBannerSlotInfo from '../../actions/setBannerSlotInfo'
import setCategoriesMenu from '../../actions/setCategoriesMenu'
import { logEventToDataCollection } from '../../data-tagging'
import { EVENTS as DT_EVENTS, FLOW_TYPES as DT_FLOW_TYPES } from '../../data-tagging/constants'
import { getSaleChannel } from '../../contexts/AnalyticsContext/utils'
import Head from '../../components/Head/Head'
import getConfig from '../../Helpers/getConfig'
import BannerFreeShippingSod from '../../components/BannerFreeShippingSod'

class Category extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      nbPages: 1,
      nbHits: 0,
      filtersMobileExpanded: false,
      isMobile: window.innerWidth < 768,
      isTablet: window.innerWidth === 768,
      searchState: urlToSearchState(props.location),
      bannerSlotInfo: urlToBannerSlotState(props.location),
      searchResult: [],
      facets: {},
      priceRange: {},
      showCarousel: null,
      showCarouselSpecialEvents: false,
      specialEventData: [],
      banners: null,
      bannersCarrousel: [],
      bannerFreeShipping: {},
      bannerFreeShippingPDP: {},
      categoryPath: '',
      infoTextBGColor: '',
      infoTextMessage: '',
      categoryName: '',
      categoryCarousel: '',
      // void PLP
      thereAreProducts: null,
      relatedProduct: [],
      shouldRenderVariants: false,
      bannerLiderBCI: {},
    }
    this.clientApi = new ClientAPI()
    this.configData = window.__ENV__
    this.clientStorage = new ClientStorage()
    this.isWalstore = this.configData.isWalstore === 'true'
    this.storageBaseUrl = this.configData.storageBaseUrl
    const { setBannerSlotInfo } = this.props
    setBannerSlotInfo({ pathname: this.props.location.pathname, ...this.state.bannerSlotInfo })
  }

  async componentDidMount() {
    const { location, selectedSODStoreId, categoriesMenu, setCategoriesMenu } = this.props
    const { categories } = categoriesMenu

    if (!categories || categories.length === 0) {
      const categoriesMenuResponse = await getCategoriesMenu()
      setCategoriesMenu(categoriesMenuResponse)
    }

    sendSimpleEvent('optimize.activate')
    const incomingSearch = urlToSearchState(location)
    await this.executeSearch(incomingSearch, selectedSODStoreId, location.pathname, true)
    const categoryCarousel = await this.clientStorage.getCarouselCategories()
    const { categoriesSpecialEvent, showCarouselSpecialEvents } = getSpecialEventData(
      categoryCarousel,
      location.pathname
    )

    this.updateStates(categoriesSpecialEvent, showCarouselSpecialEvents, categoryCarousel)
  }

  async componentWillReceiveProps(nextProps) {
    const {
      windowSize: { width },
      location: locationProp,
      selectedSODStoreId,
    } = this.props
    const { categoryCarousel } = this.state
    const { windowSize, location, selectedSODStoreId: nextSelectedSODStoreId } = nextProps

    const { isTablet, isMobile } = detectDevice(width, windowSize)
    this.setState({ isTablet })
    this.setState({ isMobile })

    if (
      locationProp.search !== location.search ||
      locationProp.pathname !== location.pathname ||
      nextSelectedSODStoreId !== selectedSODStoreId
    ) {
      const incomingSearch = urlToSearchState(location)
      if (Number.isNaN(incomingSearch.page)) {
        incomingSearch.page = 1
      }
      await this.executeSearch(incomingSearch, nextSelectedSODStoreId, location.pathname)
      const { categoriesSpecialEvent, showCarouselSpecialEvents } = getSpecialEventData(
        categoryCarousel,
        location.pathname
      )
      const bannerSlotInfo = { ...urlToBannerSlotState(location), pathname: location.pathname }
      const { setBannerSlotInfo } = this.props
      setBannerSlotInfo(bannerSlotInfo)
      this.updateStates(categoriesSpecialEvent, showCarouselSpecialEvents, categoryCarousel)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state) !== JSON.stringify(nextState)
  }

  getCategoryData = (categoryList, categories) => getCategoryDataBase(categoryList, categories)

  getCategoriesForBreadcrumbs = () => {
    const { match, setLastBreadcrumbs } = this.props
    const breadcrumbs = {
      firstLevel: {
        label: match.params.category1,
      },
      secondLevel: {
        label: match.params.category2,
      },
      thirdLevel: {
        label: match.params.category3,
      },
    }
    setLastBreadcrumbs(breadcrumbs)
    return breadcrumbs
  }

  setHitsPerPage = async (hitsPerPage) => {
    const { searchState } = this.state
    searchState.hitsPerPage = hitsPerPage
    searchState.page = 1
    const searchStateFilter = getSearchStateFilter(searchState)
    this.modifyHistory(searchStateFilter)
  }

  handleClearRefinements = () => {
    const { searchState } = this.state
    const newSearchState = searchState
    newSearchState.page = 1
    newSearchState.refinementList = {}
    const searchStateFilter = getSearchStateFilter(newSearchState)
    this.modifyHistory(searchStateFilter)
  }

  updateStates = (categoriesSpecialEvent, showCarouselSpecialEvents, categoryCarousel) =>
    this.setState((state) => ({
      ...state,
      specialEventData: categoriesSpecialEvent,
      showCarouselSpecialEvents,
      categoryCarousel,
    }))

  getConfigForCategory = async (categories) => {
    const { tenant } = this.props
    this.setState({ banners: null, showCarousel: true })

    const globalBanners = await this.clientApi.getAds(['bannersPLP'])

    const categoryConfig = await getBannersCategoryClient(categories, tenant)

    let showCarousel = false
    let bannersCarrousel = []
    let bannerFreeShipping = []
    let bannerLiderBCI = []

    if (categoryConfig) {
      if (categoryConfig.banners && categoryConfig.banners.length > 0) {
        showCarousel = true
        bannersCarrousel = categoryConfig.banners
      }
    }
    if (globalBanners && globalBanners.bannersPLP) {
      bannerLiderBCI = globalBanners.bannersPLP
    }
    if (globalBanners && globalBanners.freeShipping) {
      bannerFreeShipping = globalBanners.freeShipping
    }

    return this.setState((state) => ({
      ...state,
      categories,
      showCarousel,
      bannersCarrousel,
      bannerFreeShipping,
      bannerLiderBCI,
    }))
  }

  getUri = (searchStateFilter) => {
    const { location } = this.props
    return decodeURIComponent(searchStateToUrl(location, searchStateFilter))
  }

  modifyHistory = (searchStateFilter) => {
    const { history } = this.props
    history.push(this.getUri(searchStateFilter), searchStateFilter)
  }

  handlePageClick = (page) => {
    const { searchState } = this.state
    searchState.page = page.selected + 1

    const searchStateFilter = getSearchStateFilter(searchState)
    this.modifyHistory(searchStateFilter)
  }

  handleFacetClick = (selectedFacets, isMobile = false) => {
    const { searchState } = this.state
    searchState.refinementList = handleRefinementList(selectedFacets, searchState, isMobile)
    searchState.page = 1
    const searchStateFilter = getSearchStateFilter(searchState)
    this.modifyHistory(searchStateFilter)
  }

  handleFilterClick = (selectedValue) => {
    const { searchState } = this.state
    const { getDataForGoogleAnalytics } = this.context

    if (selectedValue?.min) {
      searchState.minPrice = selectedValue.min
    }

    if (selectedValue?.max) {
      searchState.maxPrice = selectedValue.max
    }

    searchState.page = 1
    const searchStateFilter = getSearchStateFilter(searchState)

    getDataForGoogleAnalytics({
      eventName: AnalyticsConstants.EVENTS.CHANGE_PRICE_FILTER,
      flowType: AnalyticsConstants.FLOW_TYPES.CATEGORY_RESULT,
      data: {
        maxPrice: searchStateFilter.maxPrice,
        minPrice: searchStateFilter.minPrice,
        page: searchStateFilter.page,
        origin: ORIGINS.PLP,
      },
    })

    this.modifyHistory(searchStateFilter)
  }

  handleSortBy = (value) => {
    const { searchState } = this.state
    searchState.sortBy = value
    searchState.page = 1
    const searchStateFilter = getSearchStateFilter(searchState)
    this.modifyHistory(searchStateFilter)
  }

  retryQuery = async (body) => {
    const { isTenantSod } = this.props
    return retryQueryBase(body, !isTenantSod)
  }

  forceGetConfigForCategory = async (forceGetConfigForCategory, categoriesWithoutFormat) => {
    if (forceGetConfigForCategory) {
      try {
        await this.getConfigForCategory(categoriesWithoutFormat)
      } catch (error) {
        this.setState({ showCarousel: false })
      }
    }
  }

  getFacets = (searchState) =>
    searchState.refinementList
      ? Object.entries(searchState.refinementList)
          .map((entry) => {
            const [facet, values] = entry
            return values.map((value) => `${facet}:${value}`)
          })
          .reduce((acc, currentFacet) => {
            // eslint-disable-next-line no-param-reassign
            if (!acc) acc = []
            return acc.concat(currentFacet)
          })
      : []

  async executeSearch(searchState, storeId, pathname, forceGetConfigForCategory = true) {
    const { selectedWalstoreStore } = this.props
    const { getDataForGoogleAnalytics } = this.context
    const categoriesWithoutFormat = pathname.split('category/')[1]
    const categoriesRefinement = categoriesWithoutFormat.replace(/_/g, ' ')

    const splittedCategories = categoriesRefinement.split('/')
    const categoryName = splittedCategories[splittedCategories.length - 1]

    await this.forceGetConfigForCategory(forceGetConfigForCategory, categoriesWithoutFormat)

    this.setState({ loading: true }, async () => {
      const facets = this.getFacets(searchState)

      let body = {
        categories: categoriesRefinement,
        page: searchState.page,
        facets,
        sortBy: searchState.sortBy || '',
        hitsPerPage: searchState.hitsPerPage,
      }

      if (searchState.minPrice && searchState.maxPrice) {
        body.priceRange = {
          min: searchState.minPrice,
          max: searchState.maxPrice,
        }
      }

      if (this.isWalstore && selectedWalstoreStore.id) {
        body = { ...body, storeId: selectedWalstoreStore.id }
      } else if (storeId) {
        body = { ...body, storeId }
      }

      this.setState({ thereAreProducts: null })

      if (Number.isNaN(body.page) || body.page === 0) {
        body.page = 1
      }

      const { searchResult, relatedProduct } = await this.retryQuery(body)

      if (searchResult.products && searchResult.products.length > 0) {
        const impressionData = {
          category: categoriesRefinement,
          type: 'category',
        }

        getDataForGoogleAnalytics({
          eventName: AnalyticsConstants.EVENTS.ITEM_LIST_VIEW,
          flowType: AnalyticsConstants.FLOW_TYPES.CATEGORY_RESULT,
          data: { ...searchResult, selectedWalstoreStore, origin: ORIGINS.PLP, impressionData },
        })
        this.setState({ thereAreProducts: true })
      } else {
        this.setState({ thereAreProducts: false, relatedProduct })
      }
      this.setState({
        searchResult: searchResult.products,
        dtSearchEngine: searchResult.dtSearchEngine,
        nbPages: searchResult.nbPages,
        facets: searchResult.facets,
        priceRange: searchResult.priceRange,
        loading: false,
        categoryName,
        categoryList: splittedCategories,
        searchState,
        nbHits: searchResult.nbHits,
        shouldRenderVariants: searchResult.hasVariants || false,
      })
      sendSearchResultReport('deprecated_category_result', searchResult)
      logEventToDataCollection({
        eventName: DT_EVENTS.CATEGORY_RESULT,
        flowType: DT_FLOW_TYPES.CATEGORY,
        origin: ORIGINS.PLP,
        data: {
          result: searchResult,
          state: searchState,
          url: window.location.href,
          selectedSODStoreId: storeId,
          selectedWalstoreStore,
          saleChannel: getSaleChannel(),
          dtSearchEngine: searchResult.dtSearchEngine,
          dtSearchCategories: categoriesRefinement,
        },
      })
    })
  }

  static contextType = analyticsContext
  render() {
    const {
      match,
      categoriesMenu,
      campaignConfig: { categoriesSliderMenuHeader },
      isTenantSod,
    } = this.props

    const {
      thereAreProducts,
      relatedProduct,
      isMobile,
      showCarousel,
      specialEventData,
      showCarouselSpecialEvents,
      bannerFreeShipping,
      bannersCarrousel,
      loading,
      searchState,
      searchResult,
      dtSearchEngine,
      nbPages,
      facets,
      priceRange,
      categoryName,
      categoryList,
      nbHits,
      isTablet,
      shouldRenderVariants,
      bannerLiderBCI,
    } = this.state

    if (!validateInput(/^[a-zA-ZäáàëéèíìöóòúùñçÄÀÁËÈÉÏÌÍÖÒÓÜÙÚÑ¡!0-9&, _.\-/]+$/g, match.url)) {
      return <VoidPLP thereAreProducts={false} categories={categoriesSliderMenuHeader} isMobile={isMobile} />
    }

    const categoriesBreadcrumbs = this.getCategoriesForBreadcrumbs()
    const breadcrumbsMargin = () => (isTenantSod ? '0 0 16px 0' : 'inherit')

    const { categoryFilters } = this.getCategoryData(categoryList, categoriesMenu.categories)

    const marginTop = () => `mb-4 ${isMobile ? '' : 'mt-3'}`

    const info = {
      title: categoryName,
    }

    return (
      <Fragment>
        <VoidPLP
          thereAreProducts={thereAreProducts}
          categories={categoriesSliderMenuHeader}
          relatedProduct={relatedProduct}
          isMobile={isMobile}
          showCarousel={showCarousel}
        >
          <div className="app-container app-container--category-page">
            <Head info={info} />
            {showCarousel && <BannersCarousel banners={bannersCarrousel} origin="home" />}
            <div className="container-carousel">
              <div>
                {showCarouselSpecialEvents && specialEventData && (
                  <CategoriesCarouselAbTesting data={specialEventData} isMobile={isMobile} />
                )}
              </div>
            </div>
            <Container>
              <BannerFreeShippingSod
                isMobile={isMobile}
                freeShipping={bannerFreeShipping}
                configData={getConfig()}
                className={'banner-freeshipping-plp'}
                origin={ORIGINS.PLP}
              />
              <div className="shop-wrapper">
                <div className="app-container--category-page__walstore-back-button-container">
                  {this.isWalstore && !isMobile && (
                    <div>
                      <WalstoreBackButton />
                    </div>
                  )}
                  <div className={marginTop()}>
                    {categoriesBreadcrumbs.thirdLevel && (
                      <BreadcrumbsComponent {...categoriesBreadcrumbs} margin={breadcrumbsMargin()} />
                    )}
                    <ProductsList
                      bannerLiderBCI={bannerLiderBCI}
                      isCategory
                      name={categoryName}
                      handlePageClick={this.handlePageClick}
                      handleFacetClick={this.handleFacetClick}
                      handleFilterClick={this.handleFilterClick}
                      handleSortBy={this.handleSortBy}
                      handleClearRefinements={this.handleClearRefinements}
                      facets={facets}
                      priceRange={priceRange}
                      facetsWhiteList={categoryFilters}
                      searchResult={searchResult}
                      searchState={searchState}
                      nbPages={nbPages}
                      loading={loading}
                      origin={ORIGINS.PLP}
                      flowType={AnalyticsConstants.FLOW_TYPES.CATEGORY_RESULT}
                      isMobile={isMobile}
                      isTablet={isTablet}
                      nbHits={nbHits}
                      shouldRenderVariants={shouldRenderVariants}
                      setHitsPerPage={this.setHitsPerPage}
                      dtSearchEngine={dtSearchEngine}
                    >
                      <SisterCategories originalCategories={categoryList} />
                    </ProductsList>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </VoidPLP>
        {!isTenantSod && <LegalInfo isMobile={isMobile} isCategory />}
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  windowSize: state.windowSizeReducer.windowSize,
  campaignConfig: state.campaignConfigReducer,
  lastCategory: state.lastCategoryDataReducer,
  categoriesMenu: state.categoriesMenu,
  selectedWalstoreStore: state.selectedWalstoreStore,
})

const mapDispatchToProps = (dispatch) => ({
  addToCart: (item) => dispatch(addToCart(item)),
  addOneToCart: (item) => dispatch(addOneToCart(item)),
  setLastPage: (page) => dispatch(setLastPage(page)),
  setBannerSlotInfo: (bannerSlotInfo) => dispatch(setBannerSlotInfo(bannerSlotInfo)),
  setLastBreadcrumbs: (breadcrumbs) => dispatch(setLastBreadcrumbs(breadcrumbs)),
  setCategoriesMenu: (categoriesMenu) => dispatch(setCategoriesMenu(categoriesMenu)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Category)

Category.defaultProps = {
  match: {},
  lastCategory: {},
  location: { search: '' },
  history: {},
  windowSize: {},
  categoriesMenu: { links: [], categories: [] },
  setLastBreadcrumbs: () => {},
  setBannerSlotInfo: () => {},
  setCategoriesMenu: () => {},
  selectedWalstoreStore: {},
  tenant: '',
  selectedSODStoreId: undefined,
  isTenantSod: false,
}

Category.propTypes = {
  location: PropTypes.object,
  selectedWalstoreStore: PropTypes.object,
  categoriesMenu: PropTypes.object,
  match: PropTypes.object,
  windowSize: PropTypes.object,
  lastCategory: PropTypes.object,
  history: PropTypes.object,
  setLastBreadcrumbs: PropTypes.func,
  setBannerSlotInfo: PropTypes.func,
  setCategoriesMenu: PropTypes.func,
  campaignConfig: PropTypes.any.isRequired,
  tenant: PropTypes.string,
  selectedSODStoreId: PropTypes.number,
  isTenantSod: PropTypes.bool,
}
